import { getClient } from "./client";
import type { ApiEvent, ApiMatchup, ApiTeam, GameStatus } from "./shared";

export type ApiGameHistorical = {
  id: string;
  /** Full UTC timestamp */
  timestamp: string;
  status: GameStatus;
  leaderboard: {
    rank: number;
    totalPoints: number;
  } | null;
  team: ApiTeam;
} & (
  | { typeEvent: null; typeMatchup: ApiMatchup }
  | { typeEvent: ApiEvent; typeMatchup: null }
);

export const getGameHistory = () =>
  getClient({ authenticate: true })
    .get("/api/game-history")
    .json<ApiGameHistorical[]>();
